import { useContext, useState, useEffect } from "react";
import "@aws-amplify/ui-react/styles.css";
import { CookieStorage, I18n } from "aws-amplify/utils";
import { strings } from "./strings";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ResetPasswordSuccess from "./routes/resetPasswordSuccess";
import SignIn from "./routes/signIn";
import SignUp from "./routes/signUp";
import ForgotPassword from "./routes/forgotPassword";
import ConfirmForgotPassword from "./routes/confirmForgotPassword";
import Logout from "./routes/logout";
import Profile from "./routes/profile";
import { fetchAuthSession } from "aws-amplify/auth";
import { Context } from "./contexts/context";
import SignUpSuccess from "./routes/signUpSuccess";
import AccountActivationSuccess from "./routes/accountActivationSuccess";
import AccountActivation from "./routes/accountActivation";
import SignInSuccess from "./routes/signInSuccess";
import awsconfig from "./aws-exports";

I18n.putVocabularies(strings);

const App = () => {
	const { updateUserEmail } = useContext(Context);
	const [isAuthenticated, setIsAuthenticated] = useState(false);

	useEffect(() => {
		const checkAuthState = async () => {
			const session = await fetchAuthSession();

			const cookieStorage = new CookieStorage({
				domain: ".cosmogas.com",
				sameSite: "none",
				secure: true,
			});

			const id_token =
				session?.tokens?.idToken.toString() ||
				(await cookieStorage.getItem("id_token"));
			const access_token =
				session?.tokens?.accessToken?.toString() ||
				(await cookieStorage.getItem("access_token"));
			const refresh_token =
				localStorage.getItem(
					`CognitoIdentityServiceProvider.${awsconfig.aws_user_pools_web_client_id}.${session?.tokens?.signInDetails?.loginId}.refreshToken`,
				) || (await cookieStorage.getItem("refresh_token"));
			const userEmail = session?.tokens?.signInDetails?.loginId || (await cookieStorage.getItem("userEmail"));

			if (id_token) {
				updateUserEmail(userEmail);
				cookieStorage.setItem("id_token", id_token);
				cookieStorage.setItem("access_token", access_token);
				cookieStorage.setItem("refresh_token", refresh_token);
				cookieStorage.setItem("userEmail", userEmail);
				setIsAuthenticated(true);
			} else {
				cookieStorage.removeItem("access_token");
				cookieStorage.removeItem("id_token");
				cookieStorage.removeItem("refresh_token");
				cookieStorage.removeItem("userEmail");
				setIsAuthenticated(false);
			}
		};

		checkAuthState();
	}, [window.location.href]);

	return (
		<Router>
			{isAuthenticated ? (
				<Routes>
					<Route
						path="/accountActivationSuccess"
						element={<AccountActivationSuccess />}
					/>
					<Route path="/signInSuccess" element={<SignInSuccess />} />
					<Route path="*" element={<Profile />} />
				</Routes>
			) : (
				<Routes>
					<Route path="/forgotPassword" element={<ForgotPassword />} />
					<Route
						path="/confirmForgotPassword"
						element={<ConfirmForgotPassword />}
					/>
					<Route
						path="/resetPasswordSuccess"
						element={<ResetPasswordSuccess />}
					/>
					<Route path="/accountActivation" element={<AccountActivation />} />
					<Route path="/signUp" element={<SignUp />} />
					<Route path="/signUpSuccess" element={<SignUpSuccess />} />
					<Route path="/logout" element={<Logout />} />
					<Route path="*" element={<SignIn />} />
				</Routes>
			)}
		</Router>
	);
};

export default App;
